import barba from '@barba/core';

export default class{

	constructor(){
        this.addEvented = false
        barba.hooks.beforeOnce((data) => {
            // this.gnav()
            this.message(data.next.container)
            this.scroll()
        })
        barba.hooks.beforeLeave((data) => {
            const indexEl = data.next.container.querySelector('.toppage')
            if(indexEl){
                window.removeEventListener("scroll", this.scroll);
            }
            
        })
        barba.hooks.beforeEnter((data) => {
            // this.gnav()
            this.message(data.next.container)
            this.scroll()
        });
    }
    
    message(container){
        const indexEl = container.querySelector('.toppage')
        if(indexEl){
            this.startPos = 0
            this.winScrollTop = 0
            window.addEventListener('scroll',this.scroll.bind(this));
        }
    }
    scroll(){
        this.winScrollTop = window.scrollY;
        if (this.winScrollTop >= 600) {
            // 下に200pxスクロールされたら隠す
            document.getElementById('l-header').classList.add('visible');
            document.getElementById('js-hamburger').classList.add('visible');
        } else {
            document.getElementById('l-header').classList.remove('visible');
            document.getElementById('js-hamburger').classList.remove('visible');
        }
        this.startPos = this.winScrollTop;
    }

}